import { Combobox } from '@cutilei/ui'
import { Container } from './styles'

/*
  O país do telefone, dentro do PhoneInput, sobre o Combobox do @cutilei/ui. As opções são as de
  `Phone.getCountryOptions()` (`{ value: 'BR', label: '+55', country }`), e `onChange` recebe a
  opção escolhida.

  A caixa mostra a bandeira e o DDI. Na lista, cada país vem com o nome embaixo, e a busca acha
  pelo DDI, pelo nome ou pela sigla.
*/
export default function CountrySelect({
  value,
  options = [],
  disabled = false,
  noOptionsMessage = 'Nenhum país encontrado',
  onChange = () => null
}) {
  const byCode = new Map(options.map(option => [option.value, option]))

  return (
    <Container>
      <Combobox
        size='sm'
        aria-label='País'
        placeholder='País'
        searchPlaceholder='Buscar país...'
        emptyMessage={noOptionsMessage}
        disabled={disabled}
        options={options.map(option => ({
          value: option.value,
          label: option.label,
          description: option.country.name,
          avatar: option.country.flagUrl,
          keywords: [option.value]
        }))}
        value={value?.value ?? null}
        onValueChange={code => { if (code) onChange(byCode.get(code)) }}
      />
    </Container>
  )
}
